/**
 * @generated SignedSource<<361b638f94cd9cfa5b7f1e193f485dce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignPreviews_previews$data = {
  readonly previews: ReadonlyArray<{
    readonly url: string;
  }>;
  readonly " $fragmentType": "DesignPreviews_previews";
};
export type DesignPreviews_previews$key = {
  readonly " $data"?: DesignPreviews_previews$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignPreviews_previews">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignPreviews_previews",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SidePreview",
      "kind": "LinkedField",
      "name": "previews",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Design",
  "abstractKey": null
};

(node as any).hash = "1a5aa7585d1d46abd206b5e29894088a";

export default node;
